import React, { useState, useMemo } from "react";
import PatientHistory from "./mocHistory";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  TablePagination,
} from "@mui/material";

// Mock patient data (replace with API call)
const mockPatients = [
  {
    id: 1,
    title: "Mr",
    first_name: "John",
    middle_name: "A",
    last_name: "Doe",
    dob: "1985-06-15",
    age_years: 38,
    gender: "Male",
    phone: "1234567890",
    email: "john@example.com",
    address: "123 Street, City",
    blood_group: "A+",
    department: "Cardiology ❤️",
    doctor: "Dr. Smith",
  },
  {
    id: 2,
    title: "Mrs",
    first_name: "Jane",
    middle_name: "",
    last_name: "Doe",
    dob: "1990-04-10",
    age_years: 33,
    gender: "Female",
    phone: "9876543210",
    email: "jane@example.com",
    address: "456 Avenue, City",
    blood_group: "B+",
    department: "Neurology 🧠",
    doctor: "Dr. Patel",
  },
  {
    id: 3,
    title: "Mrs",
    first_name: "xyz",
    middle_name: "",
    last_name: "trim",
    dob: "1990-04-10",
    age_years: 33,
    gender: "Female",
    phone: "9876543210",
    email: "jane@example.com",
    address: "456 Avenue, City",
    blood_group: "B+",
    department: "Neurology 🧠",
    doctor: "Dr. Patel",
  },
  // Add more mock patients here
];

const PatientSearchForm = () => {
  const [searchData, setSearchData] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    blood_group: "",
    department: "",
    doctor: "",
  });

  const [results, setResults] = useState(mockPatients);

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

//View History Stats
   const [selectedPatient, setSelectedPatient] = useState(null);
  
  
   // Sorting state
  const [orderBy, setOrderBy] = useState("first_name");
  const [order, setOrder] = useState("asc");

  const handleChange = (e) => {
    setSearchData({ ...searchData, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    const filtered = mockPatients.filter((p) => {
      return (
        (!searchData.first_name ||
          p.first_name
            .toLowerCase()
            .includes(searchData.first_name.toLowerCase())) &&
        (!searchData.last_name ||
          p.last_name.toLowerCase().includes(searchData.last_name.toLowerCase())) &&
        (!searchData.gender || p.gender === searchData.gender) &&
        (!searchData.blood_group || p.blood_group === searchData.blood_group) &&
        (!searchData.department || p.department === searchData.department) &&
        (!searchData.doctor || p.doctor === searchData.doctor)
      );
    });
    setResults(filtered);
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedResults = useMemo(() => {
    return [...results].sort((a, b) => {
      const valA = a[orderBy] || "";
      const valB = b[orderBy] || "";
      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [results, orderBy, order]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  // Row click handler
  const handleRowClick = (patient) => {
    setSelectedPatient(patient);
  };

  const handleCloseHistory = () => {
    setSelectedPatient(null);
  };



  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: 3,
        borderRadius: 3,
        boxShadow: 3,
    //   maxWidth: 1000,
        margin: "auto",
        mt: 4,
      }}
    >
      



<div
       style={{
          backgroundColor: "#860404ff", // MUI primary color
          padding: "2px",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 2px 6px rgba(112, 17, 17, 0.1)",
        }}
      >
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            fontSize: "1rem",  
            color: "white",   
            fontWeight: "bold",
          }}
        >
       🔎 Search Patients
      </Typography>
</div>




      {/* Search Filters */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <TextField
          fullWidth
          name="first_name"
          label="🧑 First Name"
          value={searchData.first_name}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        />
        <TextField
          fullWidth
          name="last_name"
          label="👤 Last Name"
          value={searchData.last_name}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        />
        <TextField
          select
          fullWidth
          name="gender"
          label="⚧ Gender"
          value={searchData.gender}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Male">👨 Male</MenuItem>
          <MenuItem value="Female">👩 Female</MenuItem>
          <MenuItem value="Other">⚧ Other</MenuItem>
        </TextField>
        <TextField
          select
          fullWidth
          name="blood_group"
          label="🩸 Blood Group"
          value={searchData.blood_group}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="A+">🅰️+ A+</MenuItem>
          <MenuItem value="A-">🅰️- A-</MenuItem>
          <MenuItem value="B+">🅱️+ B+</MenuItem>
          <MenuItem value="B-">🅱️- B-</MenuItem>
          <MenuItem value="AB+">🔴 AB+</MenuItem>
          <MenuItem value="AB-">🔴 AB-</MenuItem>
          <MenuItem value="O+">⭕+ O+</MenuItem>
          <MenuItem value="O-">⭕- O-</MenuItem>
        </TextField>
        <TextField
          select
          fullWidth
          name="department"
          label="🏢 Department"
          value={searchData.department}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Cardiology ❤️">Cardiology ❤️</MenuItem>
          <MenuItem value="Neurology 🧠">Neurology 🧠</MenuItem>
          <MenuItem value="Orthopedics 🦴">Orthopedics 🦴</MenuItem>
          <MenuItem value="Pediatrics 🧒">Pediatrics 🧒</MenuItem>
        </TextField>
        <TextField
          select
          fullWidth
          name="doctor"
          label="🧑‍⚕️ Doctor"
          value={searchData.doctor}
          onChange={handleChange}
          sx={{ flex: { xs: "1 1 100%", sm: "1 1 48%" } }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Dr. Smith">Dr. Smith</MenuItem>
          <MenuItem value="Dr. Johnson">Dr. Johnson</MenuItem>
          <MenuItem value="Dr. Patel">Dr. Patel</MenuItem>
          <MenuItem value="Dr. Brown">Dr. Brown</MenuItem>
          <MenuItem value="Dr. Wilson">Dr. Wilson</MenuItem>
          <MenuItem value="Dr. Lee">Dr. Lee</MenuItem>
          <MenuItem value="Dr. White">Dr. White</MenuItem>
          <MenuItem value="Dr. Taylor">Dr. Taylor</MenuItem>
        </TextField>
      </Box>

      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button variant="contained" onClick={handleSearch} >
          🔍 Search
        </Button>
      </Box>

      {results.length > 0 && (
        <Box mt={4} backgroundColor="#f9f9f9" p={2} borderRadius={2}  boxShadow={1}>
          {/* <Typography variant="h6" gutterBottom>
            📝 Search Results ({results.length} records)
          </Typography> */}
          <Table>
            <TableHead sx={{ backgroundColor: "#106bb5ff", color: "#fff" }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                  <TableSortLabel
                    active={orderBy === "first_name"}
                    direction={orderBy === "first_name" ? order : "asc"}
                    onClick={() => handleRequestSort("first_name")}
                  >
                    👤 Name
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                  <TableSortLabel
                    active={orderBy === "dob"}
                    direction={orderBy === "dob" ? order : "asc"}
                    onClick={() => handleRequestSort("dob")}
                  >
                    🎂 DOB / Age
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>
                  <TableSortLabel
                    active={orderBy === "gender"}
                    direction={orderBy === "gender" ? order : "asc"}
                    onClick={() => handleRequestSort("gender")}
                  >
                    ⚧ Gender
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>📞 Phone</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>🩸 Blood Group</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>🏢 Dept</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase' }}>🧑‍⚕️ Doctor</TableCell>
              </TableRow>
            </TableHead>
            {/* <TableBody>
              {sortedResults
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((p) => (
                  <TableRow key={p.id}>
                    <TableCell>
                      {p.title} {p.first_name} {p.middle_name} {p.last_name}
                    </TableCell>
                    <TableCell>
                      {p.dob ? p.dob : ""} / {p.age_years || ""}
                    </TableCell>
                    <TableCell>{p.gender}</TableCell>
                    <TableCell>{p.phone}</TableCell>
                    <TableCell>{p.blood_group}</TableCell>
                    <TableCell>{p.department}</TableCell>
                    <TableCell>{p.doctor}</TableCell>
                  </TableRow>
                ))}
            </TableBody> */}
            {/* Add for History */}
<TableBody>
          {sortedResults
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((p) => (
              <TableRow
                key={p.id}
                hover
                sx={{ cursor: "pointer" }}
                onClick={() => handleRowClick(p)} // NEW
              >
                <TableCell>
                  {p.title} {p.first_name} {p.middle_name} {p.last_name}
                </TableCell>
                <TableCell>
                  {p.dob ? p.dob : ""} / {p.age_years || ""}
                </TableCell>
                <TableCell>{p.gender}</TableCell>
                <TableCell>{p.phone}</TableCell>
                <TableCell>{p.blood_group}</TableCell>
                <TableCell>{p.department}</TableCell>
                <TableCell>{p.doctor}</TableCell>
              </TableRow>
            ))}
        </TableBody>
          </Table>








          <TablePagination
            component="div"
            count={results.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </Box>
      )}


  {selectedPatient && (
        <PatientHistory
          patient={selectedPatient}
          onClose={handleCloseHistory}
        />
      )}


    </Box>

    
  );





};

export default PatientSearchForm;
